export const config = {
  portfolio: {
    portfolioLogo: 'Portfolio',
    projectCard: {
      cards: [
        {
          heading: 'ChatBot',
          description:
            'This project aims to develop an advanced AI-powered chatbot that leverages Google Gemini AI model to provide highly accurate, context-aware, and conversational responses across diverse applications',
          animationDelay: '300',
          buttonLink: 'https://biitu-chatbot.streamlit.app/',
          buttonText: 'CHECK OUT',
        },
        {
          heading: 'Smart ATS',
          description:
            'The Resume Analyzer using Google Gemini Pro is a sophisticated tool designed to evaluate resumes with advanced AI capabilities.',
          animationDelay: '500',
          buttonLink: 'https://smart-ats.streamlit.app/',
          buttonText: 'CHECK OUT',
        },
        {
          heading: 'Q&A and Image Classification',
          description:
            'The Google Gemini project is an advanced AI initiative that integrates large language models (LLMs) and machine learning techniques for tasks such as question answering (QA) and image classification.',
          animationDelay: '900',
          buttonLink: 'https://gemini-application.streamlit.app/',
          buttonText: 'CHECK OUT',
        },
        {
          heading: 'ARTN',
          description: 'Designed and developed the artn website, ArtN is a dynamic and visually captivating website designed to immerse art enthusiasts in a rich tapestry of artistic expression.',
          animationDelay: '700',
          buttonLink: 'https://artn.netlify.app/',
          buttonText: 'CHECK OUT',
        },
        {
          heading: 'Flower-website',
          description:
            'A flower gallery website built with modern web technologies offers a visually captivating platform for floral enthusiasts, florists, and anyone with an appreciation for the beauty of flowers',
          animationDelay: '900',
          buttonLink: 'https://flower-photography.netlify.app/',
          buttonText: 'CHECK OUT',
        },
        {
          heading: 'Artwork',
          description:
            'An Artwork website serves as an online platform for artists to showcase their work and for art enthusiasts to explore, discover, and purchase art pieces.',
          animationDelay: '900',
          buttonLink: 'https://artworkwebsite.netlify.app',
          buttonText: 'CHECK OUT',
        },
      
       
      ],
    },
    internships: {
      internship: [
        {
          companyName: 'CodAlpha',
          role: '',
          introText: '',
          duration: '01/11/2023 - 01/12/2023',
          keyPointOne: 'Built a URL shortener project in Python is a program or application designed to take long URLs and generate shorter versions, commonly referred to as short links or shortened URLs.',
          keyPointTwo:
            'This tool is useful for simplifying and sharing lengthy web addresses, making them easier to manage and share.',
          keyPointThree: 'Skills - Python', 
          keyPointFour: 'IDE - Jupyter Notebook',
          offsetValue: '0',
        },
        {
          companyName: 'The Sparks Foundation',
          role: 'Data Science and Business Analytics Intern',
          introText: '',
          duration: '15/11/2023 - 15/12/2023',
          keyPointOne: 'Built a Machine Learning Model which predicts the percentage of the student on the basis of hours of study,',
          keyPointTwo: 'using simple linear regression and applying feature scaling techniques and made a supervised machine learning model on a given dataset using python.', 
          keyPointThree: 'Skils - Machine Learning, Python', 
          keyPointFour: 'IDE - Jupyter Notebook',
         
          offsetValue: '-1000',
        },
        {
          companyName: 'CodSoft',
          role: 'Python Intern',
          introText: '',
          duration: '01/10/2023 - 01/11/2023',
          keyPointOne:
            'Created Rock Paper Scissor game which is a fun and interactive desktop application built using Python and the Tkinter GUI library.This game replicates the classic hand game where players select rock, paper, or scissors, and the winner is determined based on the rules of the game.',
          keyPointTwo: ' Build Tkinter-Based Calculator, a user-friendly desktop application designed for performing basic arithmetic operations.',
          keyPointThree: 'Created Random Password Generator which is a tool designed to generate strong and unique passwords for various purposes.',
          keyPointFour: 'Skils - Machine Learning, Python, Tkinter', 
          offsetValue: '-1000',
        },
      ],
    },
  },
};

export default config;
